// extracted by mini-css-extract-plugin
module.exports = {"container":"_7WCOTwaOMHVhBLshl6WS5"};